// removed by extract-text-webpack-plugin
module.exports = {"experiences":"tnb2","title":"_1RZ0","scroller":"sk7j","item":"cIdU","slide":"_1Jq5","innerSlide":"_3sJP","ribbon":"_3j4o","sectionTitle":"_2NC4","t":"_1yBJ","img":"_1Imp","slideTitle":"_2VTD","uptitle":"P5vJ","subtitle":"_2Yo0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/scrollingexperiences/style.css
// module id = 361
// module chunks = 9